import config from '~/config';

type MetaTitleProps = {
  children: string | string[];
}

const MetaTitle = ({ children }: MetaTitleProps) => {
  const title = Array.isArray(children) ? children.join('') : children;
  return <title>{title + ' | ' + config.APP_TITLE}</title>;
}

export default MetaTitle;
